import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper } from '@mui/material';
import api from '../../api/axios';

const PlanManagement = () => {

    const [plan, setPlan] = useState({
        name: '',
        price: '',
        durationDays: '',
        maxEmployees: ''
    });

    const handleChange = (e) => {
        setPlan({ ...plan, [e.target.name]: e.target.value });
    };

    const createPlan = async () => {
        try {
            await api.post('/super-admin/plans', plan);
            alert('Plan Created');
        } catch (e) {
            alert('Error creating plan');
        }
    };

    return (
        <Box sx={{ p: 4 }}>
            <Typography variant="h5">Create Subscription Plan</Typography>

            <Paper sx={{ p: 3, mt: 2 }}>
                <TextField label="Name" name="name" fullWidth onChange={handleChange} sx={{ mb: 2 }} />
                <TextField label="Price" name="price" fullWidth onChange={handleChange} sx={{ mb: 2 }} />
                <TextField label="Duration (Days)" name="durationDays" fullWidth onChange={handleChange} sx={{ mb: 2 }} />
                <TextField label="Max Employees" name="maxEmployees" fullWidth onChange={handleChange} sx={{ mb: 2 }} />

                <Button variant="contained" onClick={createPlan}>
                    Create Plan
                </Button>
            </Paper>
        </Box>
    );
};

export default PlanManagement;